const STORAGE_PREFIX = 'cbonline_theme_';

export const THEME_OPTIONS = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'Match device' },
];

export function themeStorageKey(userId) {
  return `${STORAGE_PREFIX}${userId || 'guest'}`;
}

export function readStoredTheme(userId) {
  try {
    const v = localStorage.getItem(themeStorageKey(userId));
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch {
    /* ignore */
  }
  return 'light';
}

export function writeStoredTheme(userId, theme) {
  try {
    localStorage.setItem(themeStorageKey(userId), theme);
  } catch {
    /* ignore */
  }
}

function systemPrefersDark() {
  return window.matchMedia?.('(prefers-color-scheme: dark)')?.matches ?? false;
}

export function resolveTheme(theme) {
  if (theme === 'system') return systemPrefersDark() ? 'dark' : 'light';
  return theme === 'dark' ? 'dark' : 'light';
}

/** Apply light/dark on document (factory theme class is separate). */
export function applyTheme(theme, userId) {
  const resolved = resolveTheme(theme);
  document.documentElement.setAttribute('data-theme', resolved);
  document.body.classList.toggle('app-theme-dark', resolved === 'dark');
  if (userId) writeStoredTheme(userId, theme);
  return resolved;
}

export function initThemeListener(userId, onChange) {
  const mq = window.matchMedia?.('(prefers-color-scheme: dark)');
  if (!mq) return () => {};
  const handler = () => {
    const stored = readStoredTheme(userId);
    if (stored === 'system') {
      const resolved = applyTheme('system', userId);
      onChange?.(resolved);
    }
  };
  mq.addEventListener('change', handler);
  return () => mq.removeEventListener('change', handler);
}
